import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=a3091214&scoped=true"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=a3091214&prod&lang=scss&scoped=true"
import style1 from "./RecoverPasswordForm.vue?vue&type=style&index=1&id=a3091214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3091214",
  null
  
)

export default component.exports